export const LOGIN = '/login';
export const LOGIN_TEACHER = '/login/teacher';
export const RESET_PASSWORD = '/reset-password';
export const CREATE_ACCOUNT = '/create-account';
export const COMPLETE_ACCOUNT = '/complete-account';
export const UPDATE_PASSWORD = '/update-password';
export const HOME = '/home';

export const MY_BOOKS = '/home/mybooks';
export const CLASSES = '/home/classes';
export const CLASSES_CLASS = '/home/classes/:class?/:collection?';
export const CLASSES_ALL = '/home/classes/all';
export const CLASSES_CLASS_REQ = '/home/classes/:class/:collection?';
export const CLASSES_COLLECTION = '/home/classes/:class/:collection';
export const EXPLORE = '/home/explore';
export const ACTIVITY_LOG = '/home/activity';
export const PROFILE = '/home/profile';

export const READER_BASE = '/books';
export const READER = `/books/:vbid`;
export const COOKIE_ERROR = '/cookie-error';
export const BOOK_NOT_FOUND = '/book-not-found';
export const SYSTEM_ERROR = '/system-error';
export const BOOK_ACCESS_DENIED = '/book-access-denied';
export const FILE_NOT_FOUND = '/file-not-found';
export const NO_GROUPS = '/no-groups';

export const ADMIN = '/admin';
export const ADMIN_EXPLORE = '/admin/explore';
export const ADMIN_ALL_BOOKS = '/admin/explore/allbooks';
export const ADMIN_TAXONOMY_BASE = '/admin/explore/taxonomy';
export const ADMIN_TAXONOMY = '/admin/explore/taxonomy/:id/:category';
export const ADMIN_COLLECTIONS = '/admin/collections';
export const ADMIN_COLLECTIONS_CLASS = '/admin/collections/:class?';
export const ADMIN_COLLECTIONS_CLASS_REQ =
  '/admin/collections/:class/:collection?';
export const ADMIN_COLLECTIONS_COLLECTION =
  '/admin/collections/:class/:collection';
export const ADMIN_ROSTER = '/admin/roster';
export const ADMIN_ROSTER_CLASS = '/admin/roster/:class?';
export const ADMIN_ROSTER_CLASS_REQ = '/admin/roster/:class';

export const WEBVIEW = '/webview';
export const WEBVIEW_EXPLORE = '/webview/explore';

export const DEFAULT = '/';

export const DEV_THEME = '/dev/theme';
export const DEV_BRAND = '/dev/brand';
export const DEV_LOCALE = '/dev/locale';
export const DEV_JIGSAW_LIBRARY = '/dev/jigsaw-library';

export const REDIRECT_BASE = '/redirect';
export const REDIRECT = '/redirect/:url';

export const LOGIN_REDIRECT = '/loginredirect';
export const BOOKSHELF_READER_REDIRECT_BASE = '/reader-redirect';
export const BOOKSHELF_READER_REDIRECT = '/reader-redirect/:vbid/:url';
export const ASSIGNMENT_CREATOR_BASE = '/assignment-creator';
export const ASSIGNMENT_CREATOR =
  '/assignment-creator/:mode/:vbid/:assignmentId?';

export const DECIDE = '/user/decide';
